module.exports = __webpack_public_path__ + "img/icon-certification.58ff9366.png";